export const PROJECT_TITLE = 'Klinaro';
export const APPOINTMENT_TYPENAME = 'New Case';
export const DATE_FORMAT = 'yyyy-MM-dd';
export const DEFAULT_WEB_CAM_NAME = 'webcam_image.png';
export const DDMMYYYY_FORMAT = 'dd/MM/yyyy';
export const CASH = 'Cash';
export const ValidationPatterns = {
    phone: /^[0-9]{10}$/,                // 10 digit mobile
    pincode: /^[1-9][0-9]{5}$/,          // 6 digit pincode, not starting with 0
    alphabets: /^[a-zA-Z\s]+$/,          // only letters and spaces
    email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, // email basic pattern
    aadhar: /^[0-9]{12}$/                // 12 digit aadhar
};
export const DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
export const PAGE_SIZE_OPTIONS = [5, 10, 20, 40, 50, 100];